//React
import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as partnerAction from '../action/partnerAction';
//Add
import moment from 'moment';
import ReactPaginate from 'react-paginate';
//Material-ui
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';


class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pic: props.pic,
      list: [],
      page: 1,
      isListNext: false,
      answerAddQaId: null,
      answerAddText: '',
      answerDelQaId: null,
      datetime: null,
  	}
  }

  componentDidMount() {
    this._partnerQaQuestionListGet(1, false);
  }

  _partnerQaQuestionListGet(page, scroll) {
    this.props.partnerQaAnswerListGet(this.state.pic, page, (data) => {
      console.log(data);
      this.setState({
        list: data.list,
        page: page,
        isListNext: data.isListNext,
        datetime: new Date(),
      });
      if (scroll) {
        let elem = document.getElementById('partnerQaAnswerList');
        if (elem) {
          let rect = elem.getBoundingClientRect();
          window.scrollTo(0, (window.pageYOffset + rect.top - 50));
        }
      }
    });
  }

  _renderList(item, index) {
    return (
      <div key={index} className='box_outer'>
        <Box className='box_inner round12' boxShadow={2} style={{margin:'10px', background:'#FFF'}}>
          <div style={{padding:'2%'}}>
            <div>
              {
                (moment(item.answer_date).isValid()) && (
                  moment(item.answer_date).format("YYYY年MM月DD日")
                )
              }
            </div>
            <div style={{margin:'5px',fontWeight:'900',color:'#666'}}>
              Q. {item.question_comment}
            </div>
            <div style={{margin:'5px'}}>
              {
                (Array.isArray(item.answer_except_arr) === true) && (
                  item.answer_except_arr.map(
                    (value, index) => {return (<div key={index} style={{color:'#666'}}>A. {value}</div>)}
                  )
                )
              }
            </div>
            <div style={{margin:'5px'}}>
              <span className='orange_icon'>回答</span> {item.answer_comment}
            </div>
          </div>
        </Box>
      </div>
    );
  };

  _renderAnswer(value, index, qa_id) {
    return (
      <div key={index} style={{margin:'5px'}}>
        <Button
          size="large"
          variant="outlined"
          onClick={ () => this.setState({answerAddQaId:qa_id, answerAddText: value}) }
          style={{textAlign:'left'}}
        >
          { value }
        </Button>
      </div>
    );
  }

  _partnerQaQuestionAnswerDelSubmit() {
    this.props.partnerQaQuestionAnswerDel(this.state.answerDelQaId);
    this.setState({answerDelQaId: null});
  }

	render() {
      if (!this.state.datetime) {
        return (<div id='partnerQaAnswerList' style={{height:'1000px'}}></div>);
      }
      else {
        return (
    			<div id='partnerQaAnswerList'>
            {
              (this.state.list.length > 0) ? (
                <div>
                  <div
                    style={{
                      display:'flex',
                      flexDirection:'row',
                      alignItems:'center',
                      justifyContent: 'space-between',
                      margin: '10px',
                    }}
                  >
                    <div>
                      { this.props.qaAnswerCount }回答
                    </div>
                    <div>
                      <span style={{color:'#666'}}>ページ{this.state.page}</span>
                    </div>
                  </div>

                  {
                    this.state.list.map(
                      (value, index) => this._renderList(value, index)
                    )
                  }
                </div>
              ):(
                <h2 align='center'>回答はありませんでした</h2>
              )
            }

            {
              (Math.ceil(this.props.qaAnswerCount / 10) > 1) && (
                <div align='center'>
                  <ReactPaginate
                    breakLabel="…"
                    previousLabel="<"
                    nextLabel=">"
                    onPageChange={ (event) => this._partnerQaQuestionListGet((event.selected + 1), true) }
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    pageCount={ Math.ceil(this.props.qaAnswerCount / 10) }
                    renderOnZeroPageCount={null}
                    containerClassName={'pagingBlock'}
                    pageLinkClassName={'item'}
                    previousLinkClassName={'item'}
                    nextLinkClassName={'item'}
                    activeLinkClassName={'select'}
                    disabledClassName={'itemDisabled'}
                  />
                </div>

              )
            }

    			</div>
    		)
      }

	}
}

const mapStateToProps = (state) => {
	return {
    partner: state.partner,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...partnerAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
